import React from 'react';
import PropTypes from 'prop-types';
import { markAllAsRead } from '../actions/creators';

export default class MenuHeader extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  };

  handleClickMarkAllAsRead = () => {
    this.props.dispatch(markAllAsRead());
  };

  render() {
    return (
      <div className="notification-dropdown__header" data-mount="menu-header">
        <span className="notification-dropdown__title" data-attribute="title">Notifications</span>
        <a href="#" className="notification-dropdown__mark-as-read" data-action="mark-as-read" onClick={this.handleClickMarkAllAsRead}>Mark all as read</a>
      </div>
    );
  }
}
